/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People2Icon20Solid = forwardRef('People2Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.75 6.25a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" }),
        React.createElement("path", { d: "M14.75 11a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z" }),
        React.createElement("path", { d: "M18.007 16h-3.715c.134-.306.208-.645.208-1v-.494c0-.939-.265-1.778-.73-2.478.247-.02.492-.028.73-.028 1.991 0 4.5.604 4.5 3.006a.993.993 0 0 1-.993.994Z" }),
        React.createElement("path", { d: "M13 14.758C13 11.755 9.655 11 7 11s-6 .755-6 3.758C1 15.444 1.556 16 2.242 16h9.516c.686 0 1.242-.556 1.242-1.242Z" })));
});
